import { useQuery } from '@apollo/client/react';
import { GET_PLAN_CHANGE_PREVIEW } from '@/graphql/queries/plans';
import type { PaidPlanId, PlanChangePreviewData } from '../types';

type UsePlanChangePreviewResult = {
  preview: PlanChangePreviewData | null;
  isLoading: boolean;
  error: Error | undefined;
};

/** Paddle's prorated preview of moving to `plan`; skipped when there is nothing to change. */
export function usePlanChangePreview(
  plan: PaidPlanId,
  isSkipped: boolean,
): UsePlanChangePreviewResult {
  const { data, previousData, loading, error } = useQuery(GET_PLAN_CHANGE_PREVIEW, {
    variables: { input: { plan } },
    skip: isSkipped,
    fetchPolicy: 'network-only',
  });
  const preview = (data ?? previousData)?.planChangePreview ?? null;
  return { preview: preview?.plan === plan ? preview : null, isLoading: loading, error };
}
